import * as yup from 'yup'
import { InferType } from 'yup'

import { TTranslationFunction } from '@/types'

import { getContactSchema } from '../ContactInfoForm/contactInfoFormModel'
import {
	getFullAddressSchema,
	getUrlAddressSchema,
	TAddress,
} from '../LocationForm/addressSchema'
import { SUMMARY_MAX_LENGTH } from '../SummaryForm/SummarySection'

export const FULL_NAME_MAX_LENGTH = 300
export const COMPANY_FIELDS_MAX_LENGTH = 200

const getAddressSchema = (t: TTranslationFunction) =>
	yup.lazy((value) =>
		typeof value === 'object' &&
		value !== null &&
		typeof value.url === 'string' &&
		value.url.trim() !== ''
			? getUrlAddressSchema(t)
			: getFullAddressSchema(t),
	)

export const getAboutFormSchema = (t: TTranslationFunction) => {
	const personal = yup
		.object({
			fullName: yup
				.string()
				.required(t('ui__field_validation_errors__generic__required'))
				.max(FULL_NAME_MAX_LENGTH),
		})
		.required()

	const company = yup
		.object({
			companyName: yup.string().max(COMPANY_FIELDS_MAX_LENGTH),
			profession: yup.string().max(COMPANY_FIELDS_MAX_LENGTH),
		})
		.required()

	return yup
		.object({
			personal,
			contacts: getContactSchema(t),
			company,
			address: getAddressSchema(t),
			summary: yup.string().max(SUMMARY_MAX_LENGTH),
		})
		.required()
}

export type TAboutFormFields = Omit<
	InferType<ReturnType<typeof getAboutFormSchema>>,
	'address'
> & { address: TAddress }
